module.exports = __webpack_public_path__ + "img/error-24px.07507d7f.svg";